import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { MapBalloon } from '@yme/assets/icons';
import { MiniButton } from '@yme/atoms/mini-button';
import { useWindowSize } from '@yme/common/hooks';
import { NavList } from '@yme/components/Header/PageLevelNavigation/NavList';
import { NavListMobile } from '@yme/components/Header/PageLevelNavigation/NavListMobile';
import { selectProductCardData } from '@yme/pdp-components/ProductCard';
import { getProductDetails } from '@yme/selectors/products';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { navigationItemFromLink } from '../Menu/utils';
import { getNavigationTitle } from './helpers';
import { LinkStyled, ServiceButtonsContainerStyled } from './styled';
export function PageLevelNavigation({ title, dealerPageItem, dealerCategoryId, pageLevelNavigationItems, isUnitPDP, isRightToLeft, upButton, isClothingOrAccessoriesPDP, isDestinationPage, }) {
    const productCardData = useSelector(selectProductCardData);
    const { data: productDetailsData } = useSelector(getProductDetails);
    const { isInfiniteDesktopView } = useWindowSize();
    const isServiceButtonsExists = !isDestinationPage && Boolean(dealerPageItem);
    const navTitle = getNavigationTitle({
        isUnitPDP,
        isClothingOrAccessoriesPDP,
        title,
        unitPDPTitle: productCardData?.titleAttribute?.value,
        clothingOrAccessoriesPDPTitle: productDetailsData?.name,
    });
    const trackNavigation = useCallback((link, pageSection = 'context_menu') => {
        return () => {
            setDigitalData(DigitalDataMutation.NAVIGATION, {
                pageSection,
                navigationGroup: '',
                navigationItem: navigationItemFromLink(link),
            });
        };
    }, []);
    const NavListComponent = isInfiniteDesktopView ? NavList : NavListMobile;
    return (React.createElement(FlexWrapper, { alignItems: "center", justifyContent: "space-between", isRightToLeft: isRightToLeft },
        React.createElement(NavListComponent, { title: navTitle, pageLevelNavigationItems: pageLevelNavigationItems, isRightToLeft: isRightToLeft, upButton: upButton, trackNavigation: trackNavigation, isDestinationPage: isDestinationPage, isClothingOrAccessoriesPDP: isClothingOrAccessoriesPDP }),
        isServiceButtonsExists && (React.createElement(ServiceButtonsContainerStyled, { justifyContent: "space-between", alignItems: "center" }, dealerPageItem && (React.createElement(LinkStyled, { to: {
                pathname: dealerPageItem.link,
                search: dealerCategoryId && `?category=${dealerCategoryId?.toUpperCase()}`,
            }, onClick: trackNavigation(`${dealerPageItem.link}_${dealerCategoryId}`) },
            React.createElement(MiniButton, { iconType: MapBalloon, isRightToLeft: isRightToLeft, contentColor: colorCoreWhite1000, as: "span", isFirstIcon: true }, dealerPageItem.title)))))));
}
